










































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class StockReplenishmentCommodityView extends Vue {
  
@Watch('params.supplier')
  paramsSupplierChanged() {
    if(this.params.supplier==null){
      this.params.isShortage=Common.shortageTypes.None;
    }
}
@Watch('params.replenishmentType')
  paramsReplenishmentTypeChanged(){
    // 商品マスタの件数で検索条件の活性非活性を制御
    var countQuery = new Common.HasMinimumStockQuantityCountQuery();
    countQuery.replenishmentType = this.params.replenishmentType;
    this.$api.execute(countQuery).then(res=>{this.isShortageEnabled = res < 2000;});
  }




  public items: Common.StockReplenishmentCommodity[] = new Array(0);
  public params: Common.StockReplenishmentCommodityQuery = new Common.StockReplenishmentCommodityQuery();
  public exportQuery = new Common.StockReplenishmentCommodityExportQuery('予定在庫一覧',this.params);
  public tenantSettings: Common.TenantSettings = null;
  public visibleTypes = Common.visibleTypes;
  public usedTypes = Common.UsedTypes;
  public hasLicenseCurrency: boolean = false;
  public commodity:Common.Commodity;
  public sku:Common.SKU; 
  public isShortageEnabled: Boolean = false;
  @Prop({default:null}) public popup: Components.PopupEditor;
  @Prop() public baseDate:Date;
  @Prop() public supplierCode:string;
  @Prop() public replenishmentType:Common.ReplenishmentTypes;
  @Prop() public isShortage:boolean;

  public sortOptions: any = [
    { value: 'commodity', text: '商品' },
    { value: 'supplier', text: '仕入先' },
    { value: 'minimumStockQuantity', text: '補充基準数量' },
    { value: 'commodityCode', text: '商品コード' },
  ];

  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');
  public createPurchaseOrder = Components.CreatePurchaseOrderFromCommodity;

  // 一覧でチェックされている情報
  public checkedItems: Array<Common.StockReplenishmentCommodity>= new Array(0);
  public getCheckedItems(){
    this.checkedItems = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        this.checkedItems.push(obj);
      }
    });
  }

  public created() {

// ***** 予定在庫一覧画面の表示確認 *****
this.$api.issueGA4trackevent(this.$route.path,'【補充商品一覧】画面表示');

    this.tenantSettings = this.$api.tenantSettings;
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);

    this.gridConfig.setGridItemsFromCaptions(
      ['基準日','商品コード','商品', '型番', 'SKU','補充区分','仕入先','計上単位','予定在庫数量', '補充基準数量', '補充数量','補充単位'],
      [120, 120, 120, 120, 120, 120, 120, 120, 150, 150, 120, 120, 150, 120, 120, 120, 120, 120,]
    );
    // this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false));

    // 検索条件を設定する
    if(this.baseDate) {
      this.params.baseDate = this.baseDate;
    }
    if(this.supplierCode) {
      this.params.supplierCode = this.supplierCode;
    }
    if(this.replenishmentType) {
      this.params.replenishmentType = this.replenishmentType;
    }
    if(this.isShortage) {
      this.params.isShortage = Common.shortageTypes.IsShort;
    }

    // 商品マスタの件数で検索条件の活性非活性を制御
    var countQuery = new Common.HasMinimumStockQuantityCountQuery();
    countQuery.replenishmentType = this.params.replenishmentType;
    this.$api.execute(countQuery).then(res=>{this.isShortageEnabled = res < 2000;});
  }
  //検索予備項目
  // public isSearchVisible(usedType: Common.UsedTypes){
  //     return usedType == Common.UsedTypes.CommodityAttribute || usedType == Common.UsedTypes.StockAttribute || usedType == Common.UsedTypes.CommodityMemo ;
  // }
  // 画面のリフレッシュ(再描画)
  public refreshListView(){
    var page = (this.$refs.mainList as Components.ListView).currentPage;
    (this.$refs.mainList as Components.ListView).onPageChange(page);
  }
  
  // 発注処理ダイアログの表示
  public showCreatePurchaseOrderDialog(all:boolean = false) {

// ***** 補充商品一覧画面の発注処理押下確認 *****
this.$api.issueGA4trackevent(this.$route.path,'【補充商品一覧】発注処理・押下');

    this.getCheckedItems();
    let componentClass = Vue.extend(this.createPurchaseOrder);    
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedReplenishmentCommodity : this.checkedItems,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }
}
